// Main page scroll restoration – run first so it works even if a require() fails below.
// Handles: Turbolinks (turbolinks:load), Firefox bfcache (pageshow), popstate, load.
// Works across Chrome, Firefox, Safari, Edge and all mobile browsers.
(function() {
  var SCROLL_POSITION_KEY = 'scrollPosition';
  var SCROLL_STATE_KEY = 'scrollPageState_v1'; // richer state: scroll pos + pagination ref
  var SNAPSHOT_KEY = 'auctionListSnapshot_v1'; // full HTML of loaded auction pages
  var _snapMem = null; // in-memory copy of snapshot (survives Turbolinks, lost on hard reload)
  // Selectors for the auction list containers and their pagination links.
  // Saved before navigating to a detail page; restored instantly on back-navigation.
  var SNAPSHOT_SELS = [
    '#pills-online-auction',
    '.first_pagination',
    '#pills-auction-announcement',
    '.second_pagination',
    '#pills-notice-sale',
    '.third_pagination'
  ];
  var _restoreTimer = null;
  var _growthObserver = null; // ResizeObserver to retry scroll when page height changes
  var _topAdObserver = null; // ResizeObserver for top-ad growth compensation (Chrome back-nav fix)
  var _scrollDropGuard = null; // scroll listener that catches programmatic resets to 0
  var _sdCachedTarget = NaN; // target read once at guard creation; NaN = guard is inactive
  var _restoreInProgress = false; // guard: prevents concurrent runRestoreWithPagination calls
  var _lastSaveTime = 0; // timestamp of most recent saveScroll call
  // true once the viewport has landed within 50 px of the restore target.
  // Used to distinguish "user intentionally scrolled up" from "page not tall enough yet".
  var _restoreReached = false;
  // Turbolinks visit action ('advance' | 'replace' | 'restore' | null).
  // Captured in turbolinks:visit and consumed in turbolinks:before-render.
  // 'restore' = browser Back/Forward; 'advance' = forward link click (incl. Facebook shared URLs).
  var _turbolinksVisitAction = null;
  var _isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Firefox') !== -1;
  var LOG = function() { try { console.log.apply(console, ['[scroll-restore]'].concat(Array.prototype.slice.call(arguments))); } catch (e) {} };
  window._scrollRestoreActive = false;

  function isMainPage() { var p = (window.location.pathname || ''); return p === '/' || p === ''; }
  // popstate fires when the URL becomes '/' but Turbolinks may not have rendered the new DOM yet.
  // This check ensures we only restore scroll when the listing container is actually present.
  function isMainPageDOMReady() {
    return isMainPage() && !!document.getElementById('pills-online-auction');
  }
  function isAdDetailPath(pathname) {
    if (!pathname || pathname === '/') return false;
    var seg = (pathname.replace(/^\/|\/$/g, '') || '').split('/');
    return seg.length === 4 && /^\d+$/.test(seg[3]);
  }
  function getStoredScroll() {
    try {
      var s = (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(SCROLL_POSITION_KEY)) ||
              (typeof localStorage !== 'undefined' && localStorage.getItem(SCROLL_POSITION_KEY));
      return s || null;
    } catch (e) { return null; }
  }
  function clearStoredScroll() {
    try { sessionStorage.removeItem(SCROLL_POSITION_KEY); } catch (e) {}
    try { localStorage.removeItem(SCROLL_POSITION_KEY); } catch (e) {}
    try { sessionStorage.removeItem(SCROLL_STATE_KEY); } catch (e) {}
    try { localStorage.removeItem(SCROLL_STATE_KEY); } catch (e) {}
    if (_growthObserver) { try { _growthObserver.disconnect(); } catch(e) {} _growthObserver = null; }
    if (_topAdObserver) { try { _topAdObserver.disconnect(); } catch(e) {} _topAdObserver = null; }
    if (_scrollDropGuard) { try { window.removeEventListener('scroll', _scrollDropGuard, { passive: true }); } catch(e) {} _scrollDropGuard = null; }
    _sdCachedTarget = NaN; // deactivate guard immediately even before listener is removed
    _restoreReached = false;
    // Restore CSS overrides so user scrolling is smooth again after the restore window.
    try { var _h = document.documentElement; if (_h) {
      _h.style.removeProperty('scroll-behavior');
      _h.style.removeProperty('overflow-anchor');
    }} catch(e) {}
    window._scrollRestoreActive = false;
    hideRestoreOverlay();
  }

  function saveHTMLSnapshot() {
    if (!isMainPage()) return;
    try {
      var snap = {};
      for (var _si = 0; _si < SNAPSHOT_SELS.length; _si++) {
        var _sel = SNAPSHOT_SELS[_si];
        var _el = document.querySelector(_sel);
        if (_el) snap[_sel] = _el.innerHTML;
      }
      _snapMem = snap;
      try { sessionStorage.setItem(SNAPSHOT_KEY, JSON.stringify(snap)); } catch(e) {}
    } catch(e) {}
  }

  function restoreHTMLSnapshotTo(root) {
    var snap = _snapMem;
    if (!snap) {
      var raw;
      try { raw = sessionStorage.getItem(SNAPSHOT_KEY); } catch(e) {}
      if (!raw) return false;
      try { snap = JSON.parse(raw); } catch(e) { return false; }
    }
    var probe = root.querySelector ? root.querySelector('#pills-online-auction')
                                   : document.getElementById('pills-online-auction');
    if (!probe) return false;
    try {
      var keys = Object.keys(snap);
      for (var _ri = 0; _ri < keys.length; _ri++) {
        var _rsel = keys[_ri];
        var _rel = root.querySelector ? root.querySelector(_rsel) : document.querySelector(_rsel);
        if (_rel && snap[_rsel]) _rel.innerHTML = snap[_rsel];
      }
      return true;
    } catch(e) { return false; }
  }

  function clearHTMLSnapshot() {
    _snapMem = null;
    try { sessionStorage.removeItem(SNAPSHOT_KEY); } catch(e) {}
  }

  function getNextPageRef() {
    var sels = ['.first_pagination .next_page', '.second_pagination .next_page', '.third_pagination .next_page'];
    var best = null, bestPage = 0;
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (!el) continue;
      var href = el.getAttribute('href');
      if (!href) continue;
      var m = href.match(/[?&]page=(\d+)/);
      var p = m ? parseInt(m[1], 10) : 2;
      if (p > bestPage) { bestPage = p; best = href; }
    }
    return best; // null → all pages loaded (or only page 1 exists)
  }

  function extractPageNum(url) {
    if (!url) return 2;
    var m = url.match(/[?&]page=(\d+)/);
    return m ? parseInt(m[1], 10) : 2;
  }

  function getSavedState() {
    try {
      var s = (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(SCROLL_STATE_KEY)) ||
              (typeof localStorage !== 'undefined' && localStorage.getItem(SCROLL_STATE_KEY));
      return s ? JSON.parse(s) : null;
    } catch (e) { return null; }
  }

  function scrollToY(y) {
    var htmlEl = document.documentElement;
    try { if (htmlEl) {
      htmlEl.style.setProperty('scroll-behavior', 'auto', 'important');
      // Disable Chrome scroll anchoring during restore so ad growth doesn't visually move the page.
      htmlEl.style.setProperty('overflow-anchor', 'none', 'important');
    }} catch(e) {}
    try {
      window.scrollTo({ top: y, left: 0, behavior: 'instant' });
    } catch (e) {
      window.scrollTo(0, y);
    }
  }

  function doRestore() {
    if (!isMainPage()) return;
    try {
      var stored = getStoredScroll();
      if (!stored) return;
      var y = parseInt(stored, 10);
      if (!isFinite(y) || y < 0) return;
      var actual = window.pageYOffset !== undefined ? window.pageYOffset :
                   (document.documentElement ? document.documentElement.scrollTop : 0);
      // Don't pull the user back if they have already scrolled past the restore target.
      // This prevents the timer-based retries from causing the "page jumps up" bug on macOS/Linux.
      if (actual > y + 50) return;
      // Already at target — skip to avoid firing spurious scroll events that can trigger
      // pagination load handlers (especially the t=2000ms retry which fires unconditionally).
      if (Math.abs(actual - y) <= 10) { _restoreReached = true; return; }
      // User scrolled UP after the restore was already achieved (actual < y).
      // actual > 80 rules out a programmatic browser reset-to-zero (handled by _scrollDropGuard).
      // Ending the restore window here prevents timer retries from fighting the user.
      if (_restoreReached && actual > 80 && actual < y - 100) { clearStoredScroll(); return; }
      scrollToY(y);
      // rAF retries: Turbolinks/Firefox bfcache may reset scroll after our synchronous call.
      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(function() {
          var cur = window.pageYOffset !== undefined ? window.pageYOffset : 0;
          if (cur > y + 50) return;
          scrollToY(y);
          requestAnimationFrame(function() {
            var cur2 = window.pageYOffset !== undefined ? window.pageYOffset : 0;
            if (cur2 > y + 50) return;
            scrollToY(y);
            if (_isFirefox) {
              requestAnimationFrame(function() {
                var cur3 = window.pageYOffset !== undefined ? window.pageYOffset : 0;
                if (cur3 > y + 50) return;
                scrollToY(y);
              });
            }
          });
        });
      }
    } catch (e) {}
  }

  function doRestoreIfNeeded() {
    if (!isMainPage()) return;
    try {
      var stored = getStoredScroll();
      if (!stored) return;
      var y = parseInt(stored, 10);
      if (!isFinite(y) || y < 0) return;
      var actual = window.pageYOffset !== undefined ? window.pageYOffset :
                   (document.documentElement ? document.documentElement.scrollTop : 0);
      if (Math.abs(actual - y) <= 50) { _restoreReached = true; return; } // already at target
      if (actual > y) return; // user scrolled further down than target — leave them there
      // Restore was already achieved and user has moved up (actual < y).
      // actual > 80 rules out a browser-driven programmatic reset to near-zero.
      // Disconnect the observer so future ad/image loads no longer pull the user back.
      if (_restoreReached && actual > 80) {
        if (_growthObserver) { try { _growthObserver.disconnect(); } catch(e) {} _growthObserver = null; }
        return;
      }
      scrollToY(y);
    } catch (e) {}
  }

  function runRestoreSequence(from) {
    if (!isMainPage()) return;
    if (!getStoredScroll()) return;
    _restoreReached = false;
    window._scrollRestoreActive = true;
    if (_restoreTimer) { clearTimeout(_restoreTimer); _restoreTimer = null; }
    doRestore();
    setTimeout(doRestore, 50);
    setTimeout(doRestore, 150);
    setTimeout(doRestore, 300);
    setTimeout(doRestore, 500);
    setTimeout(doRestore, 900);
    setTimeout(doRestore, 1300);
    setTimeout(doRestore, 2000); // covers slow mobile + async ad injection
    // Firefox applies its own scroll override later than other browsers; keep extra retries only for it.
    if (_isFirefox) {
      setTimeout(doRestore, 2800);
      setTimeout(doRestore, 3600);
    }
    // ResizeObserver: re-scroll whenever page height changes (ad loading, AJAX content).
    // Created once per sequence; only fires if page is still SHORT of the target (not past it).
    // Debounced via rAF so rapid content-load bursts collapse into a single scroll attempt
    // instead of hammering doRestoreIfNeeded() for every image/ad pixel change.
    if (!_growthObserver && typeof ResizeObserver === 'function') {
      try {
        var _growthRafPending = false;
        _growthObserver = new ResizeObserver(function() {
          if (_growthRafPending) return;
          _growthRafPending = true;
          requestAnimationFrame(function() { _growthRafPending = false; doRestoreIfNeeded(); });
        });
        var _observeTarget = document.documentElement || document.body;
        if (_observeTarget) _growthObserver.observe(_observeTarget);
      } catch(e) {}
    }
    // Scroll-drop guard: detects when something (Turbolinks, Firefox/Chrome bfcache scroll restoration,
    // etc.) programmatically resets the scroll position to near-0 AFTER we've already scrolled to target.
    // Any drop from above 80px to below 80px is not user-driven — re-apply the target position.
    // Registered as passive so it never blocks scroll compositing; it only calls scrollToY() to
    // recover from a programmatic reset, which does not require preventDefault().
    // Target is read ONCE at creation time (stored in _sdCachedTarget) to avoid synchronous
    // sessionStorage reads on every scroll event, which caused severe jank on mobile Safari/Chrome.
    if (!_scrollDropGuard) {
      try {
        var _sdLastY = window.pageYOffset !== undefined ? window.pageYOffset : 0;
        var _sdInitStored = getStoredScroll();
        _sdCachedTarget = _sdInitStored ? parseInt(_sdInitStored, 10) : NaN;
        if (!isFinite(_sdCachedTarget)) _sdCachedTarget = NaN;
        _scrollDropGuard = function() {
          if (isNaN(_sdCachedTarget)) return; // deactivated by clearStoredScroll
          var cur = window.pageYOffset !== undefined ? window.pageYOffset : 0;
          var prev = _sdLastY;
          _sdLastY = cur;
          if (cur < 80 && prev > 80 && prev > cur) {
            scrollToY(_sdCachedTarget);
          }
        };
        window.addEventListener('scroll', _scrollDropGuard, { passive: true });
      } catch(e) {}
    }
    // Chrome back-navigation fix: the top ad div is inserted into <body> before the page header.
    // On a fresh Chrome reload the ad starts at height 0, so doRestore() scrolls to the saved
    // pixel position but the content there is wrong (ad height not yet taken into account).
    // When Relevant Digital then expands the ad, Chrome's scroll anchoring may shift the viewport
    // further. We watch the ad div and, once it has grown substantially, re-scroll to the original
    // saved position — which is now correct because the ad is finally at full height.
    // Firefox/mobile are unaffected (bfcache keeps the ad at full height so delta stays 0).
    if (!_topAdObserver && typeof ResizeObserver === 'function') {
      try {
        var _topAdEl = document.querySelector('[data-ad-unit-id]');
        if (_topAdEl) {
          var _topAdBaseH = Math.round(_topAdEl.getBoundingClientRect().height);
          _topAdObserver = new ResizeObserver(function() {
            var _s = getStoredScroll();
            if (!_s) {
              // Restore window already closed — clearStoredScroll may have disconnected us already.
              if (_topAdObserver) { _topAdObserver.disconnect(); _topAdObserver = null; }
              return;
            }
            var newH = Math.round(_topAdEl.getBoundingClientRect().height);
            var delta = newH - _topAdBaseH;
            if (delta > 20) { // ad grew significantly — genuine expansion, not rounding noise
              _topAdBaseH = newH; // update baseline so next callback measures from new size
              // The saved position was recorded when the ad was already at full height, so it is
              // the correct scroll target once the ad is expanded. Re-scroll to it — no delta
              // adjustment needed. This also overrides any scroll-anchoring shift Chrome applied.
              scrollToY(parseInt(_s, 10));
            }
          });
          _topAdObserver.observe(_topAdEl);
        }
      } catch(e) {}
    }
    _restoreTimer = setTimeout(function() {
      clearStoredScroll(); // also disconnects _growthObserver and _scrollDropGuard
      _restoreTimer = null;
      // Fire a synthetic scroll event so pagination handlers can check whether the user
      // reached the bottom while the restore window was blocking them (_scrollRestoreActive).
      // Fire on both window and document: $(document).on('scroll', ...) handlers need
      // the document-level event; $(window).on('scroll', ...) handlers need the window event.
      if (isMainPage()) {
        try { window.dispatchEvent(new Event('scroll')); } catch(e) {}
        try { document.dispatchEvent(new Event('scroll')); } catch(e) {}
      }
    }, _isFirefox ? 5000 : 3000); // Firefox needs longer window; other browsers are faster
  }

  // ── OVERLAY ───────────────────────────────────────────────────────────────
  // Shown while extra pages are being fetched so the user never watches content
  // build up below them (which looked like "scrolling down slowly").
  function showRestoreOverlay() {
    if (!isMainPage()) return;
    try { var el = document.getElementById('scroll-restore-overlay'); if (el) el.style.display = 'flex'; } catch(e) {}
  }
  function hideRestoreOverlay() {
    try { var el = document.getElementById('scroll-restore-overlay'); if (el) el.style.display = 'none'; } catch(e) {}
  }

  // Pagination-aware restore: reload all needed pages then jump to saved position.
  // An opaque overlay hides the content-building so the user never sees intermediate states.
  // Uses $.getScript (proven to trigger the correct .js.erb Rails response).
  // Guard: only one restore may run at a time.
  function runRestoreWithPagination(from) {
    if (!isMainPage()) return;
    if (_restoreInProgress) return;

    _restoreInProgress = true;
    window._scrollRestoreActive = true;
    var _releaseGuard = function() {
      setTimeout(function() { _restoreInProgress = false; }, 1000); // reduced from 6000ms
    };

    function doScrollNow() {
      hideRestoreOverlay();
      runRestoreSequence(from + '-afterLoad');
      _releaseGuard();
    }

    var state = getSavedState();
    if (!state || !isFinite(state.y) || state.y < 0) {
      runRestoreSequence(from); _releaseGuard(); return;
    }

    var savedNextRef = state.nextRef;
    if (!savedNextRef) {
      runRestoreSequence(from); _releaseGuard(); return;
    }

    var savedNextPage = extractPageNum(savedNextRef);
    var currentRef = getNextPageRef();
    var currentNextPage = currentRef ? extractPageNum(currentRef) : Infinity;

    if (currentNextPage >= savedNextPage) {
      runRestoreSequence(from); _releaseGuard(); return;
    }

    // If the current page is already tall enough to reach the saved scroll position,
    // skip pagination reloading entirely — avoids the Firefox "long loading screen" for users
    // whose saved position is within already-rendered content.
    var pageHeight = Math.max(
      document.documentElement ? document.documentElement.scrollHeight : 0,
      document.body ? document.body.scrollHeight : 0
    );
    if (pageHeight >= state.y + 200) {
      runRestoreSequence(from); _releaseGuard(); return;
    }

    var jq = window.jQuery || window.$;
    if (!jq || typeof jq.getScript !== 'function') { doScrollNow(); return; }

    // Show overlay immediately so the user sees a loading screen, not content building up.
    showRestoreOverlay();

    // Cap at 5 pages (reduced from 20) to limit loading time in slow browsers (e.g. Firefox).
    var maxLoads = Math.min(savedNextPage - currentNextPage, 5);
    var loadCount = 0;

    function tryLoadNext() {
      // Stop loading if the page is now tall enough to reach the saved scroll position.
      var currHeight = Math.max(
        document.documentElement ? document.documentElement.scrollHeight : 0,
        document.body ? document.body.scrollHeight : 0
      );
      if (currHeight >= state.y + 200) { doScrollNow(); return; }
      var ref = getNextPageRef();
      var nextPage = ref ? extractPageNum(ref) : Infinity;
      if (nextPage >= savedNextPage || loadCount >= maxLoads) {
        doScrollNow();
        return;
      }
      var el = document.querySelector(
        '.first_pagination .next_page, .second_pagination .next_page, .third_pagination .next_page'
      );
      if (!el) { doScrollNow(); return; }
      var url = el.getAttribute('href');
      if (!url) { doScrollNow(); return; }
      loadCount++;
      jq.getScript(url, function() { tryLoadNext(); })
        .fail(function() { doScrollNow(); });
    }

    tryLoadNext();
  }

  // Disable browser automatic scroll restoration globally so it never fights ours.
  // Set unconditionally (not just on main page) so it's always 'manual' for this tab,
  // regardless of which page the user initially lands on.
  if (typeof history !== 'undefined' && 'scrollRestoration' in history) {
    try { history.scrollRestoration = 'manual'; } catch (e) {}
  }

  function saveScroll() {
    var el = document.documentElement || document.body;
    var y = String(window.pageYOffset !== undefined ? window.pageYOffset : el.scrollTop);
    try { sessionStorage.setItem(SCROLL_POSITION_KEY, y); } catch (e) {}
    try { localStorage.setItem(SCROLL_POSITION_KEY, y); } catch (e) {}
    try {
      var state = { y: parseInt(y, 10), nextRef: getNextPageRef() };
      var stateStr = JSON.stringify(state);
      // Save to BOTH storages so pagination state survives tab memory eviction on Android.
      sessionStorage.setItem(SCROLL_STATE_KEY, stateStr);
      localStorage.setItem(SCROLL_STATE_KEY, stateStr);
    } catch (e) {}
    _lastSaveTime = Date.now();
  }

  // ── SAVE ──────────────────────────────────────────────────────────────────

  // 1. Mouse click on an auction link (primary desktop path).
  document.addEventListener('click', function(e) {
    var link = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!link || !link.href || link.target === '_blank' || link.getAttribute('rel') === 'external') return;
    if (!isMainPage()) return;
    try {
      var href = link.getAttribute('href');
      if (!href || href.indexOf('#') === 0 || href.indexOf('javascript:') === 0) return;
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      if (!isAdDetailPath(url.pathname)) return;
      saveScroll();
      saveHTMLSnapshot(); // capture all loaded pages so back-navigation is instant
    } catch (err) {}
  }, true);

  // 2. Turbolinks before-visit: catches keyboard Enter, touch, and programmatic navigation.
  document.addEventListener('turbolinks:before-visit', function() {
    if (isMainPage()) { saveScroll(); saveHTMLSnapshot(); }
  });

  // 3. pagehide: fires when browser (non-Turbolinks) navigates away, including bfcache freeze.
  //    Guard: if the click handler already saved within the last 700ms, skip — some browsers
  //    reset window.pageYOffset to 0 between the click and pagehide firing, which would
  //    overwrite the correct position captured at click time.
  window.addEventListener('pagehide', function() {
    if (!isMainPage()) return;
    if (Date.now() - _lastSaveTime < 700 && getStoredScroll()) return;
    saveScroll();
    saveHTMLSnapshot(); // fallback: ensure snapshot is saved even for non-click navigation
  });

  // NOTE: beforeunload intentionally removed — pagehide (above) covers all navigation-away
  // cases including hard unload, and beforeunload prevents bfcache on Android/Linux Chrome.

  // ── RESTORE ───────────────────────────────────────────────────────────────

  // Capture Turbolinks visit action so before-render can distinguish back-nav from forward-nav.
  // 'restore' = browser Back/Forward button; 'advance' = any forward navigation (link click,
  // Facebook shared URL, etc.). Reset to null after each turbolinks:load so stale values
  // never leak into the next navigation.
  document.addEventListener('turbolinks:visit', function(event) {
    _turbolinksVisitAction = (event.data && event.data.action) || null;
  });

  // 0. turbolinks:before-render – fires BEFORE Turbolinks swaps the page body.
  //    TWO things happen here:
  //    a) Inject the HTML snapshot into event.data.newBody so the user NEVER sees page 1
  //       when navigating back — all loaded pages are already present when the DOM swaps in.
  //    b) Lock scroll-behavior to 'auto' so Bootstrap 5's smooth-scroll setting doesn't
  //       animate Turbolinks' own scroll call. Stays locked until clearStoredScroll() resets it.
  //
  //    IMPORTANT: Only inject the snapshot for back/restore navigation ('restore' action).
  //    Forward navigations — including clicking a Facebook-shared search URL — must NOT have
  //    the snapshot injected: the server is rendering fresh, filter-specific content and
  //    injecting a stale snapshot (e.g. from a previous "paranko" search) would replace the
  //    correct server results with old, wrong content.
  document.addEventListener('turbolinks:before-render', function(event) {
    if (!getStoredScroll()) return;
    if (_turbolinksVisitAction !== 'restore') return; // forward nav — let server content stand
    // (a) Inject snapshot before render so back-navigation is instant.
    var newBody = event.data && event.data.newBody;
    if (newBody) restoreHTMLSnapshotTo(newBody);
    // (b) Lock scroll-behavior.
    try { var h = document.documentElement; if (h) h.style.setProperty('scroll-behavior', 'auto', 'important'); } catch(e) {}
  });

  // 1. turbolinks:load – fires on EVERY Turbolinks navigation (forward AND back).
  //    Snapshot was already injected in turbolinks:before-render, so all loaded pages are
  //    in the DOM. Clear the snapshot ONLY on the main page (the ad detail page fires
  //    turbolinks:load too — do NOT clear the snapshot there or back-navigation breaks).
  document.addEventListener('turbolinks:load', function() {
    _turbolinksVisitAction = null; // reset so it never leaks into the next navigation
    if (!isMainPage() || !getStoredScroll()) return; // leave snapshot intact for other pages
    clearHTMLSnapshot(); // safe to clear — we're on the main page and content is in the DOM
    runRestoreWithPagination('turbolinks:load');
  });

  // 2. popstate – Firefox sometimes fires this for back navigation WITHOUT firing
  //    turbolinks:load (e.g. when bfcache intervenes but Turbolinks still pushes state).
  //    Uses runRestoreWithPagination so extra pages are reloaded when needed.
  //    Checks _restoreInProgress first: if turbolinks:load already started restoration
  //    we skip here so the two paths don't race and clear each other's scroll state.
  window.addEventListener('popstate', function() {
    if (!isMainPage() || !getStoredScroll()) return;
    // Lock scroll-behavior immediately so the browser's own history scroll (if any) is instant.
    try { var h = document.documentElement; if (h) h.style.setProperty('scroll-behavior', 'auto', 'important'); } catch(e) {}
    // Defer so the DOM has updated to the target page before we attempt restoration.
    setTimeout(function() {
      if (!_restoreInProgress) runRestoreWithPagination('popstate');
    }, 0);
    setTimeout(function() {
      if (!_restoreInProgress) runRestoreWithPagination('popstate-delayed');
    }, 80);
    // Firefox updates the DOM later after popstate — extra retries cover the gap.
    setTimeout(function() {
      if (!_restoreInProgress && getStoredScroll()) runRestoreWithPagination('popstate-200');
    }, 200);
    if (_isFirefox) {
      setTimeout(function() {
        if (!_restoreInProgress && getStoredScroll()) runRestoreWithPagination('popstate-fx-500');
      }, 500);
    }
  });

  // Returns the PerformanceNavigationTiming type string:
  //   'navigate'      – forward navigation (link click, logo, direct URL, logo with data-turbolinks=false)
  //   'reload'        – F5 / Cmd+R / browser reload button
  //   'back_forward'  – browser Back/Forward button
  //   null            – API unavailable (old browser)
  function getNavType() {
    try {
      var entries = performance.getEntriesByType('navigation');
      if (entries && entries.length) return entries[0].type; // modern string API
    } catch(e) {}
    try {
      var t = performance.navigation && performance.navigation.type;
      if (t === 0) return 'navigate';
      if (t === 1) return 'reload';
      if (t === 2) return 'back_forward';
    } catch(e) {}
    return null;
  }

  // 3. load – initial page load (not fired on Turbolinks navigations).
  //    Snapshot injection and scroll restoration only make sense on back_forward navigation.
  //    • navigate  (logo click, direct URL, link with data-turbolinks=false):
  //        Server just rendered fresh content — discard stale snapshot and scroll state.
  //    • reload    (F5 / Cmd+R):
  //        Server rendered fresh content — skip snapshot but keep pagination/scroll state
  //        so the user stays at their position.
  //    • back_forward (browser Back button, non-Turbolinks):
  //        Inject snapshot so all previously loaded pages are instantly visible, then scroll.
  window.addEventListener('load', function() {
    if (!isMainPage() || !getStoredScroll()) return;
    var navType = getNavType();
    if (navType === 'navigate') {
      // Forward navigation: server content is authoritative. Drop stale snapshot + scroll.
      clearHTMLSnapshot();
      clearStoredScroll();
      return;
    }
    if (navType !== 'reload') {
      // back_forward or unknown: inject snapshot so all loaded pages re-appear instantly.
      restoreHTMLSnapshotTo(document);
    }
    clearHTMLSnapshot();
    runRestoreWithPagination('load');
  });

  // 4. pageshow – bfcache restore in Safari, Firefox, iOS Chrome.
  //    persisted=true: browser restored page from bfcache (Turbolinks may not fire).
  //    Firefox bfcache applies ITS OWN scroll position after pageshow fires,
  //    so we need the rAF inside doRestore AND extra setTimeout passes here.
  window.addEventListener('pageshow', function(ev) {
    if (!isMainPage() || !getStoredScroll()) return;
    // Lock scroll-behavior immediately so bfcache's own scroll restoration is also instant.
    try { var h = document.documentElement; if (h) h.style.setProperty('scroll-behavior', 'auto', 'important'); } catch(e) {}
    if (ev.persisted) {
      // Scroll immediately before Firefox/Safari can apply their own bfcache scroll position.
      doRestore();
      if (typeof requestAnimationFrame === 'function') {
        // Override the browser's bfcache scroll in the very next paint.
        requestAnimationFrame(function() { doRestore(); });
      }
      // Deferred sequences cover browsers that apply their scroll override asynchronously.
      setTimeout(function() { runRestoreSequence('pageshow-bfcache'); }, 0);
      setTimeout(function() { runRestoreSequence('pageshow-bfcache2'); }, 200);
      setTimeout(function() { runRestoreSequence('pageshow-bfcache3'); }, 700);
      setTimeout(function() { runRestoreSequence('pageshow-bfcache4'); }, 1500);
    } else {
      // Not from bfcache: page was fetched from the server.
      var navType = getNavType();
      if (navType === 'navigate') {
        // Forward navigation (logo click, direct URL): server content is authoritative.
        clearHTMLSnapshot();
        clearStoredScroll();
        return;
      }
      if (navType !== 'reload') {
        // back_forward or unknown: inject snapshot so all loaded pages re-appear instantly.
        restoreHTMLSnapshotTo(document);
      }
      clearHTMLSnapshot(); // only reached when on main page — safe to clear
      runRestoreWithPagination('pageshow');
    }
  });

  // 5. visibilitychange – handles tab switching on Android Chrome and Firefox for Android.
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible' && isMainPage() && getStoredScroll()) {
      runRestoreSequence('visibilitychange');
    }
  });
})();
